import React from 'react';
import { Skeleton } from '@mui/material';
import InfoRoundedIcon from '@mui/icons-material/InfoRounded';
import Tooltip from '@src/components/Tooltip';
import { COLOR } from '@src/styles/color';
import Typography from '@src/new-components/Typography';
import { StyledSummaryCard } from './index.style';
import { UnderlinedUnit, PercentUnit } from '../ListVoiceCard/VoiceCard';

const SummaryCard = ({
  title,
  value,
  icon,
  showTooltip = false,
  titleTooltip,
  showUnit = false,
  appDetail = true,
  loading = false,
}) => (
  <StyledSummaryCard>
    {showTooltip && (
      <div className="info-icon">
        <Tooltip title={titleTooltip} placement="left" arrow>
          <InfoRoundedIcon sx={{ fontSize: '16px', color: COLOR.indigoIcon }} />
        </Tooltip>
      </div>
    )}
    {icon}
    <Typography variant="body-14-regular" color={COLOR.descriptionUpload}>
      {title}
    </Typography>
    {appDetail ? (
      <>
        {loading ? (
          <Skeleton variant="text" width={100} height={32} />
        ) : (
          <Typography variant="body-24-bold" color={COLOR.darkGray}>
            {value}
            {showUnit && <PercentUnit />}
          </Typography>
        )}
      </>
    ) : (
      <Typography variant="body-24-bold" color={COLOR.darkGray}>
        {showUnit && <UnderlinedUnit />}
        {value}
      </Typography>
    )}
  </StyledSummaryCard>
);

export default SummaryCard;
